import React from 'react';

const capabilities = [
  {
    number: '01',
    label: 'Intelligence',
    title: 'AI that participates in the work',
    copy: 'I design LLM-powered tools, agents and automations that investigate, recommend, orchestrate and help people make better decisions.',
    proof: ['LLM applications', 'Agentic workflows', 'RAG & context', 'Evaluation']
  },
  {
    number: '02',
    label: 'Foundations',
    title: 'Systems built for the real world',
    copy: 'I architect distributed, event-driven platforms where reliability, observability and thoughtful failure handling are part of the product.',
    proof: ['Distributed systems', 'Cloud architecture', 'Event-driven design', 'Reliability']
  },
  {
    number: '03',
    label: 'Product',
    title: 'From unclear idea to useful experience',
    copy: 'I move between user problems, product choices and engineering execution—shaping not only how something works, but why it should exist.',
    proof: ['Problem framing', 'Product thinking', 'Rapid prototyping', 'Iteration']
  },
  {
    number: '04',
    label: 'Exploration',
    title: 'Learning through making',
    copy: 'I use experiments to challenge assumptions, understand emerging technology and discover possibilities that are difficult to see on paper.',
    proof: ['Experiments', 'Automation', 'Emerging AI', 'Continuous learning']
  }
];

const Skills: React.FC = () => (
  <section id="skills" className="skills-section py-24">
    <div className="section-transition" aria-hidden="true"><span>How ideas become tangible</span></div>
    <div className="skills-orbit skills-orbit-one" aria-hidden="true" />
    <div className="skills-orbit skills-orbit-two" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="skills-heading mb-12">
        <div>
          <span className="skills-eyebrow">How I create / 03</span>
          <h2 className="text-4xl md:text-6xl font-bold text-white mt-3">More than a technology stack.</h2>
        </div>
        <p className="text-lg text-gray-400 max-w-xl leading-relaxed">My work sits across intelligence, systems, product and exploration. Tools change; these are the capabilities I keep strengthening.</p>
      </div>
      <div className="capability-story-grid">
        {capabilities.map(capability => (
          <article className="capability-story-card" key={capability.number}>
            <div className="capability-story-top"><span>{capability.number}</span><em>{capability.label}</em></div>
            <h3>{capability.title}</h3>
            <p>{capability.copy}</p>
            <div className="capability-proof">{capability.proof.map(item => <span key={item}>{item}</span>)}</div>
          </article>
        ))}
      </div>
      <p className="tools-footnote">Working fluently across TypeScript, Node.js, AWS, databases, queues, caches and modern web platforms—chosen as tools, never treated as the story.</p>
    </div>
  </section>
);

export default Skills;
